module.exports = __webpack_public_path__ + "static/img/TT_logo@2x.5d591ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/TT-tiny-img/TT_logo@2x.png
// module id = G9z0
// module chunks = 1